// src/components/SaleCancelForm/parts/SaleFoundInfoRow.tsx
import React from 'react';

type Props = {
  icon: React.ReactNode;
  label: string;
  value?: React.ReactNode;
  className?: string;
};

const SaleFoundInfoRow: React.FC<Props> = ({
  icon,
  label,
  value = '—',
  className,
}) => (
  <div
    className={[
      'flex items-center gap-3 p-2 rounded-lg hover:bg-stroke/10 dark:hover:bg-strokedark/20 transition-colors',
      className ?? '',
    ].join(' ')}
  >
    {/* Icono en círculo */}
    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary dark:bg-primary/20 dark:text-primary-light shrink-0">
      {icon}
    </div>

    {/* Texto */}
    <div className="flex flex-col leading-tight min-w-0">
      <span className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
        {label}
      </span>
      <span className="truncate font-medium text-slate-700 dark:text-slate-200">
        {value}
      </span>
    </div>
  </div>
);

export default SaleFoundInfoRow;
